import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone:true,name: 'ChildrenAgePipe'})
export class ChildrenAgePipe implements PipeTransform {
  transform(element: number): string {
    const nbEnfants = element + 1;
    let libelle = `${nbEnfants}er`;
    if (nbEnfants > 1) {
      libelle = `${nbEnfants}ème`;
    }
    return libelle;
  }
}
